import { render, staticRenderFns } from "./Worksheets.vue?vue&type=template&id=3bae0143&scoped=true"
import script from "./Worksheets.vue?vue&type=script&lang=js"
export * from "./Worksheets.vue?vue&type=script&lang=js"
import style0 from "./Worksheets.vue?vue&type=style&index=0&id=3bae0143&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae0143",
  null
  
)

export default component.exports